<template>
  <div class="home-section margin-top_24">
    <el-row type="flex">
      <div class="nav-to-learning" @click="toLearning">
        <img src="../../../assets/image/nav_class.png" alt="" class="img">
      </div>
      <div class="left-content">
        <div class="matrix-content">
          <div class="section-title">
            <span class="text">网络视听行业新职业矩阵</span>
          </div>
          <el-row type="flex" justify="space-between" class="section-content">
            <div class="image-box">
              <img v-if="matrixInfo.img1" :src="matrixInfo.img1" alt="职业矩阵" class="content-image" @click="toTemp(6)" />
            </div>
            <div class="image-box">
              <img v-if="matrixInfo.img2" :src="matrixInfo.img2" alt="职业矩阵" class="content-image" @click="toTemp(7)" />
            </div>
            <div class="image-box">
              <img v-if="matrixInfo.img3" :src="matrixInfo.img3" alt="职业矩阵" class="content-image" @click="toTemp(8)" />
            </div>
          </el-row>
        </div>
        <div class="exam-content">
          <el-row type="flex" align="middle" class="section-title">
            <span class="text">考试安排</span>
            <div class="nav-button" @click="toList">查看更多 >></div>
          </el-row>
          <el-row type="flex" justify="space-between" class="list">
            <div v-for="(item, index) in examList" :key="index" class="item">
              <div class="title">{{ item.examTitle }}</div>
              <div class="content-text" v-html="item.examContent" />
            </div>
          </el-row>
        </div>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getCareerMatrixImage } from '@/api/careerMatrix'
import { getTestList } from '@/api/home/index.js'

export default {
  name: 'HomeSection2',

  data() {
    return {
      matrixInfo: {},
      examList: []
    }
  },
  created() {
    this.getExamList()
    this.getMatrixList()
  },
  methods: {
    // 获取职业举证
    getMatrixList() {
      getCareerMatrixImage().then(({ code, data }) => {
        if (code === 0) {
          this.matrixInfo = data
        }
      })
    },
    // 获取考试安排
    async getExamList() {
      try {
        const params = { page: 1, limit: 2 }
        const res = await getTestList(params)
        const {
          code,
          data: { records = [] }
        } = res
        if (code === 0) {
          this.examList = records
        }
      } catch (error) {}
    },
    toLearning() {
      window.open('https://ds.nrtatalent.cn')
    },
    toTemp(type) {
      this.$router.push(`/careerMatrix/${type}`)
    },
    // 考试安排查看更多
    toList() {
      this.$router.push({
        path: '/testPlan'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.home-section {
  box-sizing: border-box;
  // padding: 24px;
  .section-title {
    .nav-button {
      font-weight: 400;
      margin-left: auto;
      font-size: 14px;
      color: #9C9C9C;
      cursor: pointer;
    }
  }
  .section-content {
    width: 100%;
    padding-top: 16px;
    .image-box {
      width: 210px;
      height: 152px;
      border-radius: 8px;
      overflow: hidden;
      .content-image {
        width: 100%;
        height: 100%;
        vertical-align: middle;
        cursor: pointer;
      }
    }
  }
}
.nav-to-learning {
  width: 566px;
  height: 422px;
  margin-right: 24px;
  cursor: pointer;
  .img {
    width: 100%;
    height: 100%;
    vertical-align: top;
  }
}
.left-content {
  width: 0;
  flex: 1;
  box-sizing: border-box;
  padding: 24px;
  background: linear-gradient( 180deg, #DFEDFF 0%, #FFFFFF 100%, #FFFFFF 100%);
}
.exam-content {
  padding-top: 24px;
  .list {
    padding-top: 16px;
  }
  .item {
    width: 301px;
    height: 110px;
    box-sizing: border-box;
    padding: 16px;
    background: #F9F9F9;
    border-radius: 8px;
    cursor: pointer;
    &:hover {
      background-color: #085DC8;
      color: #FFFFFF;
    }
  }
  .title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 19px;
  }
  .content-text {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    font-size: 12px;
    font-weight: 400;
    width: 100%;
  }
}
</style>
